import Jobs from "../Jobs/Jobs";

export default function KioskLanding() {
  return (
    <Jobs
      detailBasePath="/kiosk"
      moduleTitle="Kiosk View"
      showJobActions={false}
    />
  );
}
